// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recording-search {
    max-width: 900px;
    margin: 0 auto;
    padding: 1rem;
}

.recording-search input[type="search"] {
    display: block;
    width: 100%;
    margin-top: 0.5rem;
    padding: 0.75rem;
}

.recording-results {
    padding: 0;
    list-style: none;
}

.recording-results li + li {
    margin-top: 0.5rem;
}

.recording-results button {
    width: 100%;
    padding: 0.75rem;
    text-align: left;
}

.soundcloud-playlists {
    margin-top: 1rem;
}

.soundcloud-playlist {
    border: 0;
}

.soundcloud-playlist--visible {
    display: block;
}

.soundcloud-playlist--hidden {
    position: fixed;
    top: 0;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/styles/SpeakerSearch.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,cAAc;IACd,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".recording-search {\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 1rem;\n}\n\n.recording-search input[type=\"search\"] {\n    display: block;\n    width: 100%;\n    margin-top: 0.5rem;\n    padding: 0.75rem;\n}\n\n.recording-results {\n    padding: 0;\n    list-style: none;\n}\n\n.recording-results li + li {\n    margin-top: 0.5rem;\n}\n\n.recording-results button {\n    width: 100%;\n    padding: 0.75rem;\n    text-align: left;\n}\n\n.soundcloud-playlists {\n    margin-top: 1rem;\n}\n\n.soundcloud-playlist {\n    border: 0;\n}\n\n.soundcloud-playlist--visible {\n    display: block;\n}\n\n.soundcloud-playlist--hidden {\n    position: fixed;\n    top: 0;\n    left: -10000px;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
